import React, { useEffect, useState } from "react";
import { supportedPreviewFormats } from "./helpers.js";

const useCreatePreview = (file, type, watchDep) => {
  const [preview, setPreview] = useState(null);

  // creating blob url for preview
  useEffect(() => {
    if (!supportedPreviewFormats.includes(type)) {
      return;
    }
    let blobURL;
    if (watchDep) {
      blobURL = URL.createObjectURL(file);

      if (blobURL) {
        setPreview(blobURL);
      }
    } else {
      URL.revokeObjectURL(blobURL);
    }

    // free memory when ever this component is unmounted
    return () => {
      if (blobURL) URL.revokeObjectURL(blobURL);
    };
  }, [watchDep]);

  return preview;
};

export default useCreatePreview;
